<template>
  <div class="wrapper">
    <Card :title="$t('pages_orders_show_670')">
      <row>
        <i-col span="16" offset="2">
          <i-form
            :rules="formRules"
            inline
            :model="product"
            ref="form"
            label-position="left"
          >
            <Row>
              <Col span="8">
                <Tooltip
                  placement="right"
                  :content="$t('pages_products_edit_796')"
                >
                  <Form-item :label="$t('pages_ai_image_158')" prop="name">
                    <Input
                      type="text"
                      :placeholder="$t('pages_products_edit_797')"
                      v-model="product.name"
                    />
                  </Form-item>
                </Tooltip>
              </Col>
              <Col span="8">
                <Form-item
                  :label="$t('pages_products_edit_798')"
                  prop="summary"
                >
                  <Input type="text" v-model="product.summary" />
                </Form-item>
              </Col>
              <Col span="8">
                <Form-item
                  :label="$t('pages_products_edit_799')"
                  prop="bar_code"
                >
                  <Input type="text" v-model="product.bar_code" />
                </Form-item>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <Form-item
                  :label="$t('pages_booking_store_products_index_213')"
                  prop="fresh_category_id"
                >
                  <Select
                    v-model="product.fresh_category_id"
                    style="width: 120px"
                    :label="product.fresh_category_name"
                    :placeholder="$t('pages_booking_store_products_index_213')"
                  >
                    <Option
                      v-for="(cat, index) in all_categories"
                      :value="cat.id"
                      :key="index"
                      >{{ cat.name }}</Option
                    >
                  </Select>
                </Form-item>
              </Col>
              <Col span="8">
                <Form-item
                  :label="$t('pages_booking_store_products_index_214')"
                  prop="unit"
                >
                  <Select
                    v-model="product.unit"
                    style="width: 120px"
                    :placeholder="$t('pages_booking_store_products_index_214')"
                  >
                    <Option
                      v-for="(cat, index) in units"
                      :value="cat.name"
                      :key="index"
                      >{{ cat.name }}</Option
                    >
                  </Select>
                </Form-item>
              </Col>
              <Col span="8">
                <Form-item
                  :label="$t('pages_products_edit_800')"
                  prop="need_to_weight"
                >
                  <i-switch size="large" v-model="product.need_to_weight">
                    <span slot="open">{{ $t("libs_table_render_50") }}</span>
                    <span slot="close">{{ $t("directives_index_41") }}</span>
                  </i-switch>
                </Form-item>
                <Form-item
                  :label="$t('pages_products_edit_801')"
                  prop="is_display"
                >
                  <i-switch size="large" v-model="product.is_display">
                    <span slot="open">{{ $t("libs_table_render_50") }}</span>
                    <span slot="close">{{ $t("directives_index_41") }}</span>
                  </i-switch>
                </Form-item>
              </Col>
            </Row>
            <Row v-if="isSingle">
              <Col span="8">
                <Form-item
                  :label="$t('pages_products_components_sku_edit_form_774')"
                  prop="jinghuojia"
                >
                  <Input type="number" v-model="product.jinghuojia" />
                </Form-item>
              </Col>
              <Col span="8">
                <Form-item
                  :label="$t('pages_ai_thirdparty_166')"
                  prop="lingshoujia"
                >
                  <Input type="number" v-model="product.lingshoujia" />
                </Form-item>
              </Col>
              <Col span="8">
                <Form-item
                  :label="$t('pages_ai_thirdparty_167')"
                  prop="huiyuanjia"
                >
                  <Input type="number" v-model="product.huiyuanjia" />
                </Form-item>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <Form-item
                  :label="$t('pages_products_edit_802')"
                  prop="is_wechat_display"
                >
                  <i-switch size="large" v-model="product.is_wechat_display">
                    <span slot="open">{{ $t("libs_table_render_50") }}</span>
                    <span slot="close">{{ $t("directives_index_41") }}</span>
                  </i-switch>
                </Form-item>
              </Col>
              <template v-if="isSingle && product.is_wechat_display">
                <Col span="8">
                  <Form-item
                    :label="$t('pages_products_components_sku_edit_form_778')"
                    prop="wechat_lingshoujia"
                  >
                    <Input type="number" v-model="product.wechat_lingshoujia" />
                  </Form-item>
                </Col>
                <Col span="8">
                  <Form-item
                    :label="$t('pages_products_components_sku_edit_form_780')"
                    prop="wechat_huiyuanjia"
                  >
                    <Input type="number" v-model="product.wechat_huiyuanjia" />
                  </Form-item>
                </Col>
                <Col span="8">
                  <Form-item
                    :label="$t('pages_products_components_sku_edit_form_782')"
                    prop="rebate_price"
                  >
                    <Input type="number" v-model="product.rebate_price" />
                  </Form-item>
                </Col>
              </template>
              <Col span="8">
                <!-- <Form-item label="开启积分" prop="score_open">
                  <i-switch size="large" v-model="product.score_open">
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                  </i-switch>
                </Form-item> -->
                <Form-item
                  :label="$t('pages_products_edit_803')"
                  prop="discount"
                >
                  <i-switch size="large" v-model="product.discount">
                    <span slot="open">{{ $t("libs_table_render_50") }}</span>
                    <span slot="close">{{ $t("directives_index_41") }}</span>
                  </i-switch>
                </Form-item>
              </Col>
              <Col span="8">
                <Form-item
                  :label="$t('pages_products_edit_804')"
                  prop="is_recommend"
                >
                  <i-switch size="large" v-model="product.is_recommend">
                    <span slot="open">{{ $t("libs_table_render_50") }}</span>
                    <span slot="close">{{ $t("directives_index_41") }}</span>
                  </i-switch>
                </Form-item>
                <Form-item
                  :label="$t('pages_products_edit_805')"
                  prop="is_market_product"
                >
                  <i-switch size="large" v-model="product.is_market_product">
                    <span slot="open">{{ $t("libs_table_render_50") }}</span>
                    <span slot="close">{{ $t("directives_index_41") }}</span>
                  </i-switch>
                </Form-item>
              </Col>
              <Col span="8">
                <Form-item
                  :label="$t('pages_products_edit_806')"
                  prop="package_price"
                >
                  <Input type="number" v-model="product.package_price" />
                </Form-item>
              </Col>
              <Col span="8">
                <Form-item :label="$t('pages_products_edit_807')" prop="code">
                  <Input type="number" v-model="product.code" />
                </Form-item>
              </Col>
              <Col span="8">
                <Form-item
                  :label="$t('pages_products_edit_808')"
                  prop="score_open"
                >
                  <i-switch size="large" v-model="product.score_open">
                    <span slot="open">{{ $t("libs_table_render_50") }}</span>
                    <span slot="close">{{ $t("directives_index_41") }}</span>
                  </i-switch>
                </Form-item>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <Form-item
                  :label="$t('pages_product_stocks_index_740')"
                  prop="stocks"
                >
                  <Input type="number" v-model="product.stocks" />
                </Form-item>
              </Col>
              <Col span="8">
                <Form-item
                  :label="$t('pages_products_edit_809')"
                  prop="stocks_warning"
                >
                  <Input type="number" v-model="product.stocks_warning" />
                </Form-item>
              </Col>
              <Col span="8">
                <Form-item
                  :label="$t('pages_products_edit_810')"
                  prop="stocks_reduce_method"
                >
                  <Select
                    v-model="product.stocks_reduce_method"
                    style="width: 120px"
                    :placeholder="$t('pages_products_edit_810')"
                  >
                    <Option
                      v-for="(method, index) in stocks_reduce_methods"
                      :value="method.value"
                      :key="index"
                      >{{ method.name }}</Option
                    >
                  </Select>
                </Form-item>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <Form-item
                  :label="$t('pages_products_edit_811')"
                  prop="address"
                >
                  <Input type="text" v-model="product.address" />
                </Form-item>
              </Col>
              <Col span="8">
                <Form-item :label="$t('pages_orders_index_635')" prop="specs">
                  <Input type="text" v-model="product.specs" />
                </Form-item>
              </Col>
              <Col span="8">
                <Form-item
                  :label="$t('pages_bookings_index_229')"
                  prop="supplier"
                >
                  <Select
                    v-model="product.fresh_supplier_id"
                    style="width: 120px"
                    :label="product.fresh_supplier_name"
                    :placeholder="$t('pages_products_edit_812')"
                  >
                    <Option
                      v-for="(cat, index) in all_suppliers"
                      :value="cat.id"
                      :key="index"
                      >{{ cat.name }}</Option
                    >
                  </Select>
                </Form-item>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <Form-item
                  :label="$t('pages_products_edit_813')"
                  prop="check_report"
                >
                  <Input type="text" v-model="product.check_report" />
                </Form-item>
              </Col>
              <Col span="8">
                <Form-item
                  :label="$t('pages_products_edit_814')"
                  prop="check_item"
                >
                  <Input type="text" v-model="product.check_item" />
                </Form-item>
              </Col>
              <Col span="8">
                <Form-item
                  :label="$t('pages_products_edit_815')"
                  prop="is_valid"
                >
                  <i-switch size="large" v-model="product.is_valid">
                    <span slot="open">{{ $t("libs_table_render_50") }}</span>
                    <span slot="close">{{ $t("directives_index_41") }}</span>
                  </i-switch>
                </Form-item>
                <Form-item
                  :label="$t('pages_products_edit_816')"
                  prop="is_binding"
                >
                  <i-switch size="large" v-model="product.is_binding">
                    <span slot="open">{{ $t("libs_table_render_50") }}</span>
                    <span slot="close">{{ $t("directives_index_41") }}</span>
                  </i-switch>
                </Form-item>
              </Col>
            </Row>
            <Form-item
              :label="$t('libs_table_render_86')"
              prop="images"
              style="width: 100%"
            >
              <uploader
                @uploadedUrl="uploadedUrl"
                v-model="product.images"
              ></uploader>
            </Form-item>
            <Form-item
              :label="$t('pages_products_components_sku_edit_form_784')"
              prop="fresh_product_customer_levels_attributes"
            >
              <CustomerLevels
                v-model="product.fresh_product_customer_levels_attributes"
              />
            </Form-item>
            <Row>
              <Col span="24">
                <Form-item
                  :label="$t('pages_products_edit_817')"
                  prop="platform_products"
                >
                  <div
                    class="platform-list"
                    v-if="
                      product.platform_products &&
                      product.platform_products.length
                    "
                  >
                    <Row
                      v-for="(item, index) in product.platform_products"
                      :key="item.name || item.temp_id"
                    >
                      <Col span="8">
                        <Form-item :label="$t('pages_products_edit_818')">
                          <Input
                            type="text"
                            :placeholder="$t('pages_products_edit_819')"
                            :value="item.name"
                            @on-change="
                              changePlatformValue('name', index, $event)
                            "
                          />
                        </Form-item>
                      </Col>
                      <Col span="6">
                        <Form-item :label="$t('pages_combo_index_282')">
                          <Input
                            type="number"
                            :placeholder="$t('pages_products_edit_820')"
                            :value="item.price"
                            @on-change="
                              changePlatformValue('price', index, $event)
                            "
                          />
                        </Form-item>
                      </Col>
                      <Col span="6">
                        <Form-item :label="$t('pages_products_edit_821')">
                          <Input
                            type="number"
                            :placeholder="$t('pages_products_edit_822')"
                            :value="item.sales"
                            @on-change="
                              changePlatformValue('sales', index, $event)
                            "
                          />
                        </Form-item>
                      </Col>
                      <Col span="4" class="handles">
                        <Icon
                          type="ios-add-circle-outline"
                          @click="addPlatform"
                        />
                        <Icon
                          type="ios-remove-circle-outline"
                          @click="removePlatform(index)"
                        />
                      </Col>
                    </Row>
                  </div>
                  <Button v-else @click="addPlatform">{{
                    $t("pages_products_edit_823")
                  }}</Button>
                </Form-item>
              </Col>
            </Row>
          </i-form>
        </i-col>
      </row>
    </Card>
    <Card class="m-t-12">
      <div slot="title">
        <Tooltip placement="right" :content="$t('pages_products_edit_824')">
          <h3 style="cursor: pointer">
            {{ $t("pages_products_edit_825") }}<Icon type="ios-alert-outline" />
          </h3>
        </Tooltip>
      </div>
      <SpecEdit
        ref="editSku"
        :add-enable="!!form.name"
        :value="allSkus"
        :product="detail"
        :single="isSingle"
        @addSku="onAddSkuOpen"
        @save="saveProductAndAllSkus"
        @clearSku="onClearMultiSku"
        @onEditSkuProp="onEditSkuProp"
      />
    </Card>
    <Card class="m-t-12">
      <div slot="title">
        <Tooltip placement="right" :content="$t('pages_products_edit_826')">
          <h3 style="cursor: pointer">
            {{ $t("pages_products_edit_827") }}<Icon type="ios-alert-outline" />
          </h3>
        </Tooltip>
      </div>
      <PreferencesEdit v-model="product.fresh_product_preferences" />
    </Card>
    <Card class="m-t-12">
      <div slot="title">
        <h3>
          {{ $t("pages_products_edit_828")
          }}<Button type="primary" @click.prevent="editMaterial">{{
            $t("pages_products_edit_829")
          }}</Button>
        </h3>
      </div>
      <TablePaginate
        :columns="columns"
        :data="product.fresh_material_fresh_products"
        :loading="loadingProducts"
        :noPagination="true"
      ></TablePaginate>
    </Card>
    <Card class="m-t-12">
      <div slot="title">
        <h3>
          {{ $t("setting_new_1344")
          }}<Button type="primary" @click.prevent="editTax">{{
            $t("pages_products_edit_829")
          }}</Button>
        </h3>
      </div>
      <TablePaginate
        :columns="taxColumns"
        :data="product.products_taxes"
        :loading="loadingProducts"
        :noPagination="true"
      ></TablePaginate>
    </Card>
    <!-- <Card class="m-t-12">
      <div slot="title">
        <Tooltip placement="right"
                 content="单属性商品无需添加">
          <h3 style="cursor: pointer">属性信息
            <Icon type="ios-alert-outline" />
          </h3>
        </Tooltip>
      </div>
      <PreferEdit ref="editSku"
                :add-enable="!!form.name"
                :value="allSkus"
                :product="detail"
                :single="isSingle"
                @addSku="onAddSkuOpen"
                @save="saveProductAndAllSkus"
                @clearSku="onClearMultiSku" />
    </Card> -->
    <Card class="footer-wrapper">
      <div class="footer">
        <i-button type="default" size="large" @click="resetForm">{{
          $t("pages_products_edit_830")
        }}</i-button>
        <i-button type="primary" size="large" @click="saveAll">{{
          $t("pages_products_edit_831")
        }}</i-button>
      </div>
    </Card>
    <NewSkuModal
      :visible="newSkuModal"
      :fixed-specs="skuAddSpecs"
      :current-sku-prop="currentSkuProp"
      @toggle="toggleNewSkuVisible"
      @submit="onAddSku"
    />
    <EditMaterialModal
      :visible="editMaterialModal"
      :selected="product.fresh_material_fresh_products"
      @toggle="editMaterial"
      @submit="onEditMaterial"
    />
    <EditTaxModal
      :visible="EditTaxModal"
      :selected="product.products_taxes"
      @toggle="editTax"
      @submit="onEditTax"
    />
  </div>
</template>

<script>
import i18n from "../../locales/index";

import { mapState, mapActions, mapGetters } from "vuex";
import Uploader from "@/components/uploader-aliyun/list";
import SpecEdit from "./components/spec-edit";
// import PreferEdit from './components/prefer-edit';
import NewSkuModal from "./components/new-sku-modal";
import EditMaterialModal from "./components/edit-material-modal";
import EditTaxModal from "./components/edit-tax-modal";
import PreferencesEdit from "./components/preferences-edit";
import TablePaginate from "@/components/TablePaginate";
import { getSkuMeta } from "./utils";
import {
  get,
  pick,
  map,
  difference,
  filter,
  identity,
  find,
  uniq,
  uniqBy,
} from "lodash";
import CustomerLevels from "./customer_levels";

function defaults() {
  return {
    name: "",
    mall_category_id: null,
    images: [],
    maximum_limit: 0,
    minimum_limit: 1,
    stocks_warning: 0,
    stocks_reduce_method: "",
  };
}

export default {
  name: "EditProducts",
  components: {
    Uploader,
    SpecEdit,
    // PreferEdit,
    NewSkuModal,
    CustomerLevels,
    EditMaterialModal,
    PreferencesEdit,
    TablePaginate,
    EditTaxModal,
  },
  data() {
    const vm = this;
    return {
      oldTaxArr:[],
      isNew: false, // 是否是创建商品
      isSingle: true, // 单规格
      newSkuModal: false, // 显示添加 sku 的弹窗
      currentSkuProp: [],
      currentSkuPropIndex: "",
      detail: {},
      formRules: {
        name: [{ required: true, message: i18n.t("pages_products_edit_832") }],
        // summary: [{ required: true, message: "商品描述不能为空" }],
        fresh_category_id: [
          { required: true, message: i18n.t("pages_products_edit_833") },
        ],
        unit: [{ required: true, message: i18n.t("pages_products_edit_834") }],
        lingshoujia: [
          {
            validator(rule, value, callback) {
              const required = !!value || value === 0 || value === "0";
              return vm.isSingle ? required : true;
            },
            required: true,
            message: i18n.t("pages_products_components_sku_edit_form_786"),
          },
        ],
        huiyuanjia: [
          {
            validator(rule, value, callback) {
              const required = !!value || value === 0 || value === "0";
              return vm.isSingle ? required : true;
            },
            required: true,
            message: i18n.t("pages_products_components_sku_edit_form_785"),
          },
        ],
        jinghuojia: [
          {
            validator(rule, value, callback) {
              const required = !!value || value === 0 || value === "0";
              return vm.isSingle ? required : true;
            },
            required: true,
            message: i18n.t("pages_products_components_sku_edit_form_787"),
          },
        ],
        wechat_lingshoujia: [
          {
            validator(rule, value, callback) {
              const required = !!value || value === 0 || value === "0";
              return (vm.product ? vm.product.is_wechat_display : true) &&
                vm.isSingle
                ? required
                : true;
            },
            required: true,
            message: i18n.t("pages_products_components_sku_edit_form_788"),
          },
        ],
        wechat_huiyuanjia: [
          {
            validator(rule, value, callback) {
              const required = !!value || value === 0 || value === "0";
              return (vm.product ? vm.product.is_wechat_display : true) &&
                vm.isSingle
                ? required
                : true;
            },
            required: true,
            message: i18n.t("pages_products_components_sku_edit_form_789"),
          },
        ],
      },
      // 添加第一个 sku 时，选中的规格就会锁定，比如选择了颜色和尺寸，后续添加的商品只能包含颜色和属性，不能增减属性
      skuAddSpecs: [],
      stocks_reduce_methods: [
        { name: i18n.t("pages_products_edit_835"), value: "unpaid" },
        { name: i18n.t("pages_products_edit_836"), value: "paid" },
        { name: i18n.t("pages_products_edit_837"), value: "finished" },
      ],
      form: defaults(),
      newSkus: [],
      columns: [
        {
          type: "index",
          width: 100,
          align: "center",
        },
        {
          title: i18n.t("pages_materials_index_616"),
          key: "fresh_material_name",
        },
        {
          title: i18n.t("pages_combo_index_282"),
          key: "fresh_material_price",
          align: "center",
        },
      ],
      taxColumns: [
        {
          type: "index",
          width: 100,
          align: "center",
        },
        {
          title: i18n.t("pages_banners_index_181"),
          key: "name",
        },
        {
          title: i18n.t("setting_new_1345"),
          key: "scope_text",
        },
        {
          title: i18n.t("setting_new_1344"),
          key: "rate",
        },
      ],
      editMaterialModal: false,
      EditTaxModal: false,
    };
  },
  computed: {
    ...mapState("product", {
      products: "products",
      product: "product",
      productPagination: "meta",
      loadingProducts: "loading",
    }),
    ...mapState("customer_level", ["customer_levels"]),
    ...mapGetters("unit", ["units"]),
    ...mapGetters("category", {
      all_categories: "all_categories",
    }),
    ...mapGetters("supplier", ["all_suppliers"]),
    ...mapState("mall_sku", {
      skuList: "mall_skus",
      skuPagination: "meta",
    }),
    skuList() {
      return (this.product && this.product.mall_skus) || [];
    },
    allSkus() {
      console.info("allSkus", this.skuList, this.newSkus);
      return this.skuList.concat(this.newSkus);
    },
  },
  async mounted() {
    const { id } = this.$route.params;
    this.init(id);
    this.fetchCustomerLevels({ per: 65535 });
  },
  watch: {
    product: {
      immediate: false,
      async handler(value) {
        this.form = { ...value };
        if (value && value.id) {
          // await this.fetchSkuList({ mall_product_id: value.id });
          const skuLength = get(value, ["mall_skus", "length"], 0);
          const firstSkuSpecLength = get(
            value,
            ["mall_skus", 0, "mall_properties", "length"],
            0
          );

          if (skuLength != 0) {
            this.isSingle = false;
          } else {
            this.isSingle =
              (value && !value.multi_species) ||
              skuLength === 0 ||
              (skuLength === 1 && firstSkuSpecLength === 0);
          }

          const sku = find(
            get(value, ["mall_skus"], []),
            (i) => i.mall_properties && i.mall_properties.length > 0
          );
          if (sku) {
            const ids = [];
            const specs = sku.mall_properties;
            specs.forEach((item) => {
              if (!item._destroy) {
                ids.push(item.mall_property_name_id);
              }
            });
            console.log("specs", specs, ids);
            this.skuAddSpecs = uniq(ids);
          }

          this.product.fresh_material_fresh_products_origin = [
            ...value.fresh_material_fresh_products,
          ];
          this.product.platform_products = value.platform_products || [];
          this.product.fresh_product_preferences_origin = [
            ...value.fresh_product_preferences,
          ];
          this.product.mall_skus.map(
            (sku) =>
              (sku.fresh_product_customer_levels_attributes =
                sku.fresh_product_customer_levels)
          );
        }
      },
    },
  },
  methods: {
    ...mapActions("product", {
      create: "create",
      update: "update",
      show: "show",
    }),
    ...mapActions("customer_level", {
      fetchCustomerLevels: "index",
    }),
    ...mapActions("category", ["allCategory"]),
    ...mapActions("supplier", ["allSuppliers"]),
    ...mapActions("unit", { unit_index: "index" }),
    ...mapActions("tax", { tax_index: "index" }),
    async init(id) {
      const isNew = id === "new";
      await this.unit_index({ per: 100 });
      await this.tax_index({ per: 100 });
      await this.allCategory({});
      await this.allSuppliers({});
      this.isNew = isNew;
      if (!isNew) {
        await this.show(id);
        this.product.fresh_category_id =
          this.product.fresh_category && this.product.fresh_category.id;
        this.product.fresh_supplier_id =
          this.product.fresh_supplier && this.product.fresh_supplier.id;
        this.product.fresh_product_customer_levels_attributes =
          this.product.fresh_product_customer_levels;

        this.isSingle = this.product.multi_species === false;
       
        this.product.products_taxes =  this.product.products_taxes.map(
          (data) => {
            return {
              id:data.id,
              tax_id: data.tax.id,
              name: data.tax.name,
              rate:data.tax.rate,
              scope_text:data.tax.scope_text
            };
          }
        );


       

        this.product.products_taxes_attributes = this.product.products_taxes.map(
          (data) => {
            return {
              id:data.id,
              tax_id:data.tax_id,
              _destroy:false
            };
          }
        );


         this.oldTaxArr = this.product.products_taxes
      }
      this.detail = this.product;
      console.log("this.product", this.product);
    },
    uploadedUrl(url) {
      // if (this.product.images) {
      //   this.product.images.push(url)
      // } else {
      //   this.product.images = [url];
      // }
    },
    toggleNewSkuVisible() {
      this.newSkuModal = !this.newSkuModal;
    },
    validProduct() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid) => {
          resolve(!!valid);
        });
      });
    },
    // 保存商品和所有 sku 数据
    async saveProductAndAllSkus(skusEditList) {
      // this.product.fresh_product_preferences_attributes = this.product.fresh_product_preferences;
      // 商品基本信息
      const productInfo = pick(this.product, [
        "name",
        "summary",
        "fresh_category_id",
        "image",
        "unit",
        "code",
        "bar_code",
        "lingshoujia",
        "huiyuanjia",
        "jinghuojia",
        "special_price",
        "is_display",
        "is_recommend",
        "need_to_weight",
        "stocks",
        "huiyuanjia_open",
        "score_open",
        "discount",
        "fresh_supplier_id",
        "fresh_product_customer_levels_attributes",
        "is_wechat_display",
        "stocks_reduce_method",
        "stocks_warning",
        "wechat_lingshoujia",
        "wechat_huiyuanjia",
        "rebate_price",
        "mall_sku",
        "maximum_limit",
        "minimum_limit",
        "images",
        "is_binding",
        "specs",
        "address",
        "check_report",
        "check_item",
        "platform_products",
        // "fresh_product_preferences",
        // "fresh_product_preferences_attributes",
        "package_price",
        "is_market_product",
        "products_taxes_attributes",
      ]);

      if (Array.isArray(productInfo.fresh_product_customer_levels_attributes)) {
        productInfo.fresh_product_customer_levels_attributes.map((data) => {
          if (typeof data.id === "string" && data.id.charAt(0) === "j") {
            delete data.id;
          }
          return data;
        });
      }
      const skus = skusEditList
        .map((item) => item.detail)
        .map((sku, index) => {
          const properties = pick(sku, "mall_properties").mall_properties || [];
          sku = this.isSingle
            ? []
            : pick(sku, [
                "id",
                "name",
                "image",
                "sales",
                "quantity",
                "stocks",
                "lingshoujia",
                "jinghuojia",
                "huiyuanjia",
                "fresh_product_customer_levels_attributes",
                "wechat_huiyuanjia",
                "wechat_lingshoujia",
                "rebate_price",
              ]);
          const uniqProperties = uniqBy(
            map(properties, (i) => {
              return pick(i, [
                "mall_property_name_id",
                "mall_property_value_id",
                "id",
              ]);
            }),
            "mall_property_value_id"
          );
          const destroyedIds = difference(
            filter(map(properties, "id"), identity),
            filter(map(uniqProperties, "id"), identity)
          );
          uniqProperties.push(
            ...map(destroyedIds, (item) => ({ id: item, _destroy: "1" }))
          );
          if (Array.isArray(sku.fresh_product_customer_levels_attributes)) {
            sku.fresh_product_customer_levels_attributes.map((data) => {
              if (typeof data.id === "string" && data.id.charAt(0) === "j") {
                delete data.id;
              }
              return data;
            });
          }

          return {
            ...sku,
            huiyuanjia: +sku.huiyuanjia || 0,
            lingshoujia: +sku.lingshoujia || 0,
            jinghuojia: +sku.jinghuojia || 0,
            sales: +sku.sales || 0,
            quantity: +sku.quantity || 0,
            stocks: +sku.stocks || 0,
            stocks_warning: +sku.stocks_warning || 0,
            mall_properties_attributes: uniqProperties,
          };
        });
      productInfo.mall_skus_attributes = skus;
      const destroyed = difference(map(this.skuList, "id"), map(skus, "id"));
      productInfo.mall_skus_attributes.push(
        ...destroyed.map((id) => ({ id, _destroy: "1" }))
      );

      // 是否为多规格商品
      productInfo.multi_species = skus.length;

      // 属性信息
      const destroyedPreferenceId = difference(
        map(this.product.fresh_product_preferences_origin, "id"),
        map(this.product.fresh_product_preferences, "id")
      );
      const addedPreferenceId = difference(
        map(this.product.fresh_product_preferences, "id"),
        map(this.product.fresh_product_preferences_origin, "id")
      );

      const originPreference = map(
        this.product.fresh_product_preferences_origin,
        (item) => {
          const { id } = item;
          const { name, values } =
            this.product.fresh_product_preferences.find(
              (item) => item.id === id
            ) || {};

          return {
            id,
            name,
            values,
            _destroy: destroyedPreferenceId.includes(id),
          };
        }
      );

      const newPreference = [];
      map(this.product.fresh_product_preferences, (item) => {
        const { id } = item;
        if (addedPreferenceId.includes(id)) {
          newPreference.push({
            ...item,
          });
        }
      });
      console.info(
        this.product.fresh_product_preferences,
        this.product.fresh_product_preferences_origin,
        originPreference,
        newPreference
      );
      productInfo.fresh_product_preferences_attributes =
        originPreference.concat(newPreference);

      // 商品小料
      const destroyedMaterialId = difference(
        map(
          this.product.fresh_material_fresh_products_origin,
          "fresh_material_id"
        ),
        map(this.product.fresh_material_fresh_products, "fresh_material_id")
      );
      const addedMaterialId = difference(
        map(this.product.fresh_material_fresh_products, "fresh_material_id"),
        map(
          this.product.fresh_material_fresh_products_origin,
          "fresh_material_id"
        )
      );

      const originMaterial = map(
        this.product.fresh_material_fresh_products_origin,
        (item) => {
          const { id, fresh_material_id } = item;
          return {
            fresh_material_id,
            id,
            _destroy: destroyedMaterialId.includes(fresh_material_id),
          };
        }
      );

      const newMaterial = [];
      map(this.product.fresh_material_fresh_products, (item) => {
        const { fresh_material_id } = item;
        if (addedMaterialId.includes(fresh_material_id)) {
          newMaterial.push({
            fresh_material_id,
          });
        }
      });
      productInfo.fresh_material_fresh_products_attributes =
        originMaterial.concat(newMaterial);

      // console.info('productInfo', productInfo, this.isSingle)
      if (!this.isSingle) {
        productInfo.jinghuojia = productInfo.jinghuojia || 0;
        productInfo.lingshoujia = productInfo.lingshoujia || 0;
        productInfo.huiyuanjia = productInfo.huiyuanjia || 0;
      }
      if (this.product && this.product.id) {
        await this.update({ id: this.product.id, ...productInfo });
        // await this.init(this.product.id)
        this.$router.push("/products");
      } else {
        await this.create(productInfo);
        // const { id } = await this.create(productInfo);
        // this.$router.replace(`/products/${this.product.id}/edit`);
        this.$router.push("/products");
        // this.$nextTick(() => {
        //   this.init(id);
        // });
      }
    },
    onClearMultiSku() {
      this.skuAddSpecs = [];
      this.currentSkuProp = [];
      this.isSingle = true;
    },
    onAddSkuOpen() {
      this.currentSkuProp = [];
      this.isSingle = false;
      this.newSkuModal = true;
    },
    onEditSkuProp(props, index) {
      this.onAddSkuOpen();
      this.currentSkuProp = props;
      this.currentSkuPropIndex = index;
    },
    onAddSku(specs) {
      const meta = getSkuMeta({ mall_properties: specs });
      let existItem = null;
      let existIndex = null;
      const isExit = this.allSkus.some((item, index) => {
        const itemMeta = getSkuMeta(item);
        const exist = itemMeta.uniqIndex === meta.uniqIndex;
        if (exist) {
          existItem = item;
          existIndex = index;
        }
        return exist;
      });
      if (
        isExit &&
        ((this.currentSkuProp.length &&
          existIndex !== this.currentSkuPropIndex) ||
          !this.currentSkuProp.length)
      ) {
        this.$Message.error(
          i18n.t("pages_products_edit_838", [
            (existItem && existItem.name) || "商品",
          ])
        );
        return;
      }

      const skuName =
        (this.product.name || this.form.name || "") + " " + meta.name;

      if (this.currentSkuProp.length) {
        // 编辑
        if (!isExit) {
          this.$refs.editSku.editSkuProp({
            newSpecs: specs,
            newName: skuName,
            index: this.currentSkuPropIndex,
          });
        }
      } else {
        // 新增
        if (specs.length) {
          const ids = [];
          specs.forEach((item) => {
            ids.push(item.mall_property_name_id);
          });
          this.skuAddSpecs = ids;
        }

        // 交给子组建去添加
        this.$refs.editSku.submitAddSku({
          huiyuanjia: "",
          lingshoujia: "",
          image: "",
          mall_product_id: this.product.id,
          name: skuName,
          mall_properties: specs,
          sales: 0,
          stocks: 0,
        });
      }

      this.newSkuModal = false;
    },
    // 保存商品 + sku 数据
    async saveAll() {
      const productValid = await this.validProduct();
      const skusValid = this.$refs.editSku.allSkuValid;
      const platformValid = this.checkPlatformValue();
      console.info("saveall", productValid, skusValid, platformValid);
      if (productValid && skusValid && platformValid) {
        this.$refs.editSku.save();
      } else {
        this.$Message.error(i18n.t("pages_products_edit_839"));
      }
    },
    async resetForm() {
      const { id } = this.$route.params;
      if (id) {
        this.init(id);
      }
    },
    // 编辑小料
    editMaterial() {
      this.editMaterialModal = !this.editMaterialModal;
    },
    editTax() {
      this.EditTaxModal = !this.EditTaxModal;
    },
    // 保存小料
    onEditMaterial(materials) {
      this.product.fresh_material_fresh_products = materials;
    },
    onEditTax(data) {
      this.product.products_taxes = data;
      if(this.oldTaxArr.length == 0){
         this.product.products_taxes_attributes = this.product.products_taxes.map(
          (data) => {
            return {
              tax_id: data.id,
            };
          }
        );
      }else{
        this.oldTaxArr.forEach((item,index)=>{
          if(!this.product.products_taxes.some(obj => obj.id === item.tax_id)){
            if(this.product.products_taxes_attributes[index]._destroy == false){
               this.product.products_taxes_attributes[index]._destroy = true
            }
          }
        })

        this.product.products_taxes.forEach((item)=>{
          if(!this.product.products_taxes_attributes.some(obj => obj.tax_id === item.id)){
            this.product.products_taxes_attributes.push({tax_id:item.id})
          }
        })
      }
    },
    // 新增平台价设置
    addPlatform() {
      if (!this.product.platform_products) {
        this.$set(this.product, "platform_products", []);
      }
      this.product.platform_products.push({
        temp_id: Math.random().toFixed(2),
        name: "",
        price: "",
        sales: "",
      });
    },
    removePlatform(index) {
      this.product.platform_products.splice(index, 1);
    },
    changePlatformValue(target, index, event) {
      const { value } = event.target;
      this.product.platform_products[index][target] = value;
    },
    checkPlatformValue() {
      let valid = true;
      if (this.products.platform_products) {
        this.product.platform_products.map((item) => {
          const { name, price, sales } = item;
          if (!name || !price || !sales) {
            valid = false;
          }
        });
      }

      return valid;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 20px;
  padding-bottom: 70px;
  .ivu-col-span-8 {
    height: 90px;
  }
  .platform-list {
    float: left;
    width: 100%;
    background: #f5f5f5;
    border-radius: 5px;
    padding: 12px 20px;
    .handles {
      font-size: 25px;
      margin-top: 34px;
      i {
        cursor: pointer;
        margin-left: 5px;
      }
    }
  }
}
.m-t-12 {
  margin-top: 12px;
  button {
    margin-left: 15px;
  }
}

.switch-mode {
  margin-left: 12px;
  font-size: 14px;
}

.footer-wrapper {
  position: fixed;
  bottom: 0;
  left: 250px;
  right: 0;
  z-index: 5;
  .footer {
    text-align: left;
    padding-right: 30px;
    > button {
      width: 200px;
      margin-left: 20px;
    }
  }
}
</style>
